import React from 'react';
import type { ImageAsset } from '../data/resinContent';
type CroppedImageProps = {
  image: ImageAsset;
  className?: string;
  loading?: 'lazy' | 'eager';
  /** Pass true when the image is described elsewhere (thumbnails). */
  decorative?: boolean;
};

/**
 * Shows a pixel region of a larger source image while keeping the
 * region's own aspect ratio. Size it from the outside with width or height.
 */
export function CroppedImage({
  image,
  className = '',
  loading = 'lazy',
  decorative = false
}: CroppedImageProps) {
  const c = image.crop ?? {
    x: 0,
    y: 0,
    w: image.width,
    h: image.height
  };
  return <div className={`relative overflow-hidden ${className}`} style={{
    aspectRatio: `${c.w} / ${c.h}`
  }} data-id="element-74" data-mp="3b5brtk0pujqx">
      <img src={image.src} alt={decorative ? '' : image.alt} loading={loading} width={image.width} height={image.height} className="absolute" style={{
      maxWidth: 'none',
      height: 'auto',
      width: `${image.width / c.w * 100}%`,
      left: `${-c.x / c.w * 100}%`,
      top: `${-c.y / c.h * 100}%`
    }} data-id="element-75" data-mp="366qzs7vmb6dk" />
    </div>;
}
export function cropRatio(image: ImageAsset): number {
  const c = image.crop ?? {
    x: 0,
    y: 0,
    w: image.width,
    h: image.height
  };
  return c.w / c.h;
}